import { Record } from 'immutable';
import { createReducer, identify } from 'angieslist-app-platform';
import { getCookie } from 'angieslist-app-platform/lib/common/utils/cookieUtils';
import { get } from 'lodash';
import userActionKeys from '../user/userActionKeys';

const InitialState = new Record({
  identify: {
    userId: null,
    tracked: false,
  },
});

export default createReducer(new InitialState(), {
  [userActionKeys.GET_USER_SUCCESS]: (state, action) => {
    const segmentTrackedId = getCookie('ajs_user_id');
    const user = get(action, 'payload.body', {});
    const identifiedAlready = Number(user.userId) === Number(segmentTrackedId);
    if (!state.get('identify.tracked') && !identifiedAlready) {
      return identify({
        userId: parseInt(user.userId, 10),
        firstName: user.firstName,
        lastName: user.lastName,
        email: user.email,
      })
        ? state.merge({
          identify: {
            userId: parseInt(user.userId, 10),
            tracked: true,
          },
        })
        : state;
    }
    return state;
  },
});



// WEBPACK FOOTER //
// ./src/app/common/analytics/analyticsReducer.js